import * as types from '../constants/action.types';
import { IAction } from '../constants/action';
import categoriesService from '../api/categories.service';

function requestCategories(): IAction {
    return { type: types.CATEGORIES_REQUESTED };
}

function categoriesReceived(downloads): IAction {
    return { type: types.CATEGORIES_RETRIEVED, data: downloads };
}

function categoriesFailed(error): IAction {
    return { type: types.CATEGORIES_FAILED, data: error };
}

function getCategories() {
    return dispatch => {
        dispatch(requestCategories());

        categoriesService.getCategories().then(categories => {
            dispatch(categoriesReceived(categories));
            dispatch(changePage(1));
        }, err => {
            dispatch(categoriesFailed(err));
        });
    }
}

function shouldFetchCategories(state) {
    const categories = state.categories;

    if (categories.isFetching) {
        return false;
    }
    else {
        return categories.loaded === false;
    }
}

export function selectCategory(category: string) {
    return { type: types.CHANGE_CATEGORY, data: category };
}

export function changePage(page: number): IAction {
    return { type: types.CATEGORIES_CHANGE_PAGE, data: page };
}

export function getCategoriesfNeeded() {
    return (dispatch, getState) => {
        if (shouldFetchCategories(getState())) {
            return dispatch(getCategories());
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/categories.action.ts